// Дзеркало src/MedDevice.Shared/Authorization/AppPermissions.cs — меню показує лише модулі,
// які сервер дозволить ролі хоча б читати (ModuleAuthorizationMiddleware інакше віддасть 403).
// Змінюючи матрицю на сервері, оновити й тут.

export type AppModule =
  | 'WMS'
  | 'Inventory'
  | 'Sales'
  | 'Customers'
  | 'Purchases'
  | 'Suppliers'
  | 'Products'
  | 'Finance'
  | 'AR'
  | 'ServiceRequests'
  | 'InstalledBase'
  | 'Users'
  | 'Admin';

const MD_ALL_MODULES: AppModule[] = [
  'WMS', 'Inventory', 'Sales', 'Customers', 'Purchases', 'Suppliers', 'Products',
  'Finance', 'AR', 'ServiceRequests', 'InstalledBase', 'Users', 'Admin',
];

const MD_FULL_ACCESS: Record<string, AppModule[]> = {
  Admin: MD_ALL_MODULES,
  Director: MD_ALL_MODULES,
  StorekeeperManager: ['WMS', 'Inventory'],
  SalesManager: ['Sales', 'Customers'],
  PurchaseManager: ['Purchases', 'Suppliers'],
  ServiceEngineer: ['ServiceRequests'],
  Accountant: ['Finance', 'AR'],
};

const MD_READ_ONLY: Record<string, AppModule[]> = {
  StorekeeperManager: ['Purchases', 'Products'],
  SalesManager: ['WMS', 'Products'],
  PurchaseManager: ['WMS', 'Products'],
  ServiceEngineer: ['InstalledBase', 'Products'],
  Accountant: ['Sales'],
};

const MD_FORBIDDEN: Record<string, AppModule[]> = {
  StorekeeperManager: ['Finance', 'Users'],
  SalesManager: ['Finance', 'Users', 'Admin'],
  PurchaseManager: ['Finance', 'Users'],
  ServiceEngineer: ['Finance', 'Users', 'Admin'],
  Accountant: ['WMS', 'ServiceRequests'],
};

/** Чи може хоч одна з ролей щонайменше читати модуль (та сама логіка, що в middleware для GET). */
export function mdCanReadModule(mdRoles: readonly string[], mdModule: AppModule): boolean {
  return mdRoles.some((mdRole) => {
    if (MD_FORBIDDEN[mdRole]?.includes(mdModule)) return false;
    return !!MD_FULL_ACCESS[mdRole]?.includes(mdModule) || !!MD_READ_ONLY[mdRole]?.includes(mdModule);
  });
}

/** Чи має хоч одна з ролей повний доступ до модуля — лише він пропускає POST/PUT/DELETE у middleware. */
export function mdCanWriteModule(mdRoles: readonly string[], mdModule: AppModule): boolean {
  return mdRoles.some((mdRole) =>
    !MD_FORBIDDEN[mdRole]?.includes(mdModule) && !!MD_FULL_ACCESS[mdRole]?.includes(mdModule));
}
